import { SelectionModel } from '@angular/cdk/collections';
import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, FormControl, Validators } from "@angular/forms";
import { Customer } from "@app/core/models/customer.model";
import { ActivatedRoute, Router } from "@angular/router";
import { BooleanInput } from "@angular/cdk/coercion";
import { CustomerService } from "@app/core/services/customer.service";
import { UserAlertService } from "@app/shared/services/user-alert.service";
import { CustomerContact } from "@app/core/models/customer-contact.model";
import { Country } from '@app/core/models/country.model';
import { DialogData } from '@app/shared/models/dialog-data';
import { DialogAction } from '@app/shared/models/dialog-action';
import { DialogComponent } from '@app/shared/components/dialog/dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-customer-contact-page',
  templateUrl: './customer-contact-page.component.html',
  styleUrls: ['./customer-contact-page.component.css']
})
export class CustomerContactPageComponent implements OnInit{
	@Input()
	parentForm!: FormGroup;
	private _initialDetails?: CustomerContact = undefined;
	private _readonly: BooleanInput = true;
	customer?: Customer;
	contact?: CustomerContact;
	//selections?: SelectionModel<CustomerContact>;
	agency?: Customer;
	form!: FormGroup;
	id: FormControl;
	firstName: FormControl;
	lastName: FormControl;
	phone: FormControl;
	email: FormControl;
	fax: FormControl;
	mobile: FormControl;
	address: FormControl;
	city: FormControl;
	province: FormControl;
	country: FormControl;
	zipcode: FormControl;
	default: Boolean;
	materialContact: Boolean;
	proofContact: Boolean;
	isGdprConsentAccepted = false;

	public countries: Country[] = [];

	set Country(code : string) {
		this.setFormValueIfNotEmpty("country",code);
	}
	get Country() {
		return this.getFormValueIfNotEmpty("country");
	}

	// TODO - What is this?
	isReadOnly()  {
		return false;
		//return this._readonly;
	}

	isValid() {
		return this.isGdprConsentAccepted && this?.form?.status == "VALID";
	}

	initDefaults() {
			// return any values back to initial states
			if (this.form && this != undefined && this.contact != undefined) {
				this.setFormValueIfNotEmpty("id", this.contact.id);
				this.setFormValueIfNotEmpty("firstName", this.contact.firstName);
				this.setFormValueIfNotEmpty("lastName", this.contact.lastName);
				this.setFormValueIfNotEmpty("phone", this.contact.phone);
				this.setFormValueIfNotEmpty("fax", this.contact.fax);
				this.setFormValueIfNotEmpty("email", this.contact.email);
				this.setFormValueIfNotEmpty("mobile", this.contact.mobile);
				this.setFormValueIfNotEmpty("address", this.contact.address);
				this.setFormValueIfNotEmpty("city", this.contact.city);
				this.setFormValueIfNotEmpty("province", this.contact.province);
				this.setFormValueIfNotEmpty("country", this.contact.country);
				this.setFormValueIfNotEmpty("zipcode", this.contact.zipCode);
				this.setFormValueIfNotEmpty("JobRole", this.contact.jobRole?.label); // Note: this field is not yet created anywhere and throws an error
				this.default = this?.contact?.default || false;
				this.materialContact = this?.contact?.materialContact || false;
				this.proofContact = this?.contact?.proofContact || false;
			}
	}

	clickEditButton() {
		this._readonly = !this._readonly;
		if (this._readonly) {
			this.initDefaults();
		}

	}

	constructor(private formBuilder: FormBuilder,
				private _route: ActivatedRoute,
				private _router: Router,
				private _userAlertService: UserAlertService,
				private _dialog: MatDialog,
				private _customerService: CustomerService
		) { //}, private appConfigService: AppConfigService) {
		this.id = this.formBuilder.control(this._initialDetails?.id || "");
		this.firstName = this.formBuilder.control(this._initialDetails?.firstName || "", [Validators.required, Validators.maxLength(20)]);
		this.lastName = this.formBuilder.control(this._initialDetails?.lastName || "", [Validators.required, Validators.maxLength(25)]);
		this.phone = this.formBuilder.control(this._initialDetails?.phone || "", [Validators.maxLength(16)]);
		this.fax = this.formBuilder.control(this._initialDetails?.fax || "", [Validators.maxLength(16)]);
		this.email = this.formBuilder.control(this._initialDetails?.email || "", [Validators.maxLength(250), Validators.email]);
		this.mobile = this.formBuilder.control(this._initialDetails?.mobile || "", [Validators.maxLength(16)]);
		this.address = this.formBuilder.control(this._initialDetails?.address || "", [Validators.maxLength(40)]);
		this.city = this.formBuilder.control(this._initialDetails?.city || "");
		this.province = this.formBuilder.control(this._initialDetails?.province || "");
		this.country = this.formBuilder.control(this._initialDetails?.country || "", [Validators.maxLength(2)]);
		this.zipcode = this.formBuilder.control(this._initialDetails?.zipCode || "", [Validators.maxLength(12)]);
		this.default = false;
		this.materialContact = false;
		this.proofContact = false;
		//this.isDefault = this.formBuilder.control(this.initDefaults?.isDefault || false);
		//this.net = this.formBuilder.control(this._initialDetails?.net || "");

		const nav = this._router.getCurrentNavigation();
		if (nav && nav.extras && nav.extras.state) {
			this.customer = nav.extras.state['customer'];
			this.agency = nav.extras.state['agency'];
			this.countries = nav.extras.state['countries'];
			//this.selections = nav.extras.state['selections'];
			//if (this.selections && this?.selections?.selected && this?.selections?.selected?.length > 0) {
			//	this.contact = this.selections?.selected[0]; // first one will do for now.
			//} else {
				this.contact = nav.extras.state['contact'];
			//}

			if (nav.extras.state['preselectMaterial']) {
				this.materialContact = true;
			}

			if (nav.extras.state['preselectProof']) {
				this.proofContact = true;
			}
		}

		this.form = new FormGroup({});
		this._dialog = _dialog;
	}

	isDefaultToggle() {
		this.default = !this.default;
	}

	getIsDefault():boolean {
		return this.default.valueOf();
	}

	isProofToggle() {
		this.proofContact = !this.proofContact;
	}

	getIsProof():boolean {
		return this.proofContact.valueOf();
	}

	isMaterialToggle() {
		this.materialContact = !this.materialContact;
	}

	getIsMaterial():boolean {
		return this.materialContact.valueOf();
	}

	getCustomerContactDetails(): CustomerContact {

		const customerContactDetails = new CustomerContact();

		customerContactDetails.id = this.getFormValueIfNotEmpty('id');
		customerContactDetails.email = this.getFormValueIfNotEmpty('email');
		customerContactDetails.fax = this.getFormValueIfNotEmpty('fax');
		customerContactDetails.mobile = this.getFormValueIfNotEmpty('mobile');
		customerContactDetails.firstName = this.getFormValueIfNotEmpty('firstName');
		customerContactDetails.lastName =this.getFormValueIfNotEmpty('lastName');
		customerContactDetails.address = this.getFormValueIfNotEmpty('address');
		customerContactDetails.city = this.getFormValueIfNotEmpty('city');
		customerContactDetails.province = this.getFormValueIfNotEmpty('province');
		customerContactDetails.country = this.getFormValueIfNotEmpty('country');
		customerContactDetails.zipCode = this.getFormValueIfNotEmpty('zipcode');
		customerContactDetails.phone = this.getFormValueIfNotEmpty('phone');
		customerContactDetails.default = this.default;
		customerContactDetails.materialContact = this.materialContact;
		customerContactDetails.proofContact = this.proofContact;
		return customerContactDetails;
	}

	ngOnInit(): void {
		//this.form = this.parentForm;
		this.form.addControl("id", this.id);
		this.form.addControl("firstName", this.firstName);
		this.form.addControl("lastName", this.lastName);
		this.form.addControl("email", this.email);
		this.form.addControl("phone", this.phone);
		this.form.addControl("fax", this.fax);
		this.form.addControl("mobile", this.mobile);
		this.form.addControl("address", this.address);
		this.form.addControl("city", this.city);
		this.form.addControl("province", this.province);
		this.form.addControl("country", this.country);
		this.form.addControl("zipcode", this.zipcode);

		//this.form.addControl("province", this.province);
		//this.form.addControl("net", this.net);
		if (this.customer) {
			this._initialDetails = this.customer;
			this.initDefaults();
		}
	}

	private setFormValueIfNotEmpty(fieldName: string, fieldValue?: string) {
		if (this.form && fieldValue) {
			this.form.controls[fieldName].setValue(fieldValue);
		}
	}

	private getFormValueIfNotEmpty(fieldName: string)  {
		return this.form?.controls[fieldName]?.value;
	}

	modifyCustomerContact() {
		if (this != undefined && this.customer != undefined) {
			const contact = this.getCustomerContactDetails();
			var modified = false;
			// make sure there is a contacts collection.
			if (this.customer?.contacts == undefined ) {
				if (this && this.customer) {
				this.customer.contacts = [];
				}
			}
			if (this.contact == undefined) { // was selections
				this.customer.contacts?.push(contact);
				modified = true;
			}
			else if (this && this.customer && this.customer.contacts) {
				for(var index = 0; index < this.customer.contacts.length; index++) {
					if (this.customer.contacts[index].id == contact?.id) {
						this.customer.contacts[index] = contact;
						modified = true;
					} else if (contact?.default) {
						// if this contact is default, make all other contacts not default.
						this.customer.contacts[index].default = false; // clear any other default
					}
				}
			}
			if (modified) {
				this._customerService.createOrUpdateCustomer(this?.agency?.id, this.customer).
				subscribe(
					updatedCustomer => {
						this._router.navigate(["advertiser"], { state: { customer: updatedCustomer, agency: this.agency } });
					},
					// TODO NOT SURE WHAT WE WANT TO DO FOR ERROR HANDLING
					error => { this._userAlertService.error("FAILED : " + error.errorMessageKey)});

			} else {
				this._router.navigate(["advertiser"], { state: { customer: this.customer, agency: this.agency } });
			}
		}
	}

	confirmDeleteCustomerContact(): void {
		const submitActionId = "delete";
		const dialogData = new DialogData();
		dialogData.messageKey = "CUSTOMER_DETAILS.DELETE_CONFIRMATION_MESSAGE.CONFIRM_REMOVE_CONTACT";
		dialogData.actions = [
			new DialogAction(submitActionId, "ACTION_BUTTON_LABELS.DELETE", true),
			new DialogAction("", "ACTION_BUTTON_LABELS.CANCEL", false),
		];
		const dialogRef = this._dialog.open(DialogComponent, { data: dialogData	});
		dialogRef.afterClosed().subscribe({
			next: (actionId: string) => {
				if (actionId === submitActionId) this.deleteCustomerContact();
			}
		});
	}



	deleteCustomerContact() {
		if (this != undefined && this.customer != undefined && this.contact != undefined && this.customer.contacts != undefined) {
			var modified = false;
			// any contacts we wish to remove... remove them
			const contact = this.contact;
			for(var index = this.customer.contacts.length-1; index >= 0; index--) {
				if (this.customer.contacts[index].id == contact?.id) {
					this.customer.contacts.splice(index,1);
					modified = true;
					break;
				}
			}
			// once removed we then delete them from the customer.
			if (modified) {
					this._customerService.createOrUpdateCustomer(this?.agency?.id, this.customer).
					subscribe(
						updatedCustomer => {
							this.customer = updatedCustomer;
							this._router.navigate(["advertiser"], { state: { customer: updatedCustomer, agency: this.agency } });
						},
						// TODO NOT SURE WHAT WE WANT TO DO FOR ERROR HANDLING
						error => { this._userAlertService.error("FAILED:${error}")});

				} else {
					this._router.navigate(["advertiser"], { state: { customer: this.customer, agency: this.agency } });
				}
			}

	}


	closeCustomerContact() {
		if (this && this.customer) {
			this._router.navigate(["advertiser"], { state: { customer: this.customer, agency: this.agency } });
		}
	}

}
